import { render } from "./HomeAssistant.vue?vue&type=template&id=a8ce6f54&scoped=true"
import script from "./HomeAssistant.vue?vue&type=script&lang=js"
export * from "./HomeAssistant.vue?vue&type=script&lang=js"

import "./HomeAssistant.vue?vue&type=style&index=0&id=a8ce6f54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ce6f54"]])

export default __exports__